
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sprachschule-faq-deutschsprachkursesprachpruefungen",
      function () {
        return require("private-next-pages/sprachschule-faq-deutschsprachkursesprachpruefungen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sprachschule-faq-deutschsprachkursesprachpruefungen"])
      });
    }
  